// src/components/AnnouncementCard.js
// Updated: 08/27/2025 12:15 PM

import React, { useState } from 'react';
import { Card, CardContent, Typography, Box, IconButton, Collapse, Link, List, ListItem, ListItemIcon, ListItemText } from '@mui/material'; // ADDED List, ListItem, ListItemIcon, ListItemText
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import ExpandLessIcon from '@mui/icons-material/ExpandLess';
import FiberNewIcon from '@mui/icons-material/FiberNew';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import AttachFileIcon from '@mui/icons-material/AttachFile';


function AnnouncementCard({ announcement, userRole, onEdit, onDelete, isRead, onMarkAsRead }) {
  const isLeadership = userRole === 'Leadership' || userRole === 'Church Administrator';
  // FIX: Added a check to ensure createdAt exists and has a toDate method before calling it.
  const creationDate = announcement.createdAt && typeof announcement.createdAt.toDate === 'function' 
                         ? announcement.createdAt.toDate().toLocaleDateString()
                         : 'N/A';

  const [expanded, setExpanded] = useState(false);

  const handleExpandClick = () => {
    setExpanded(!expanded);
    if (!isRead) {
      onMarkAsRead(announcement.id);
    }
  };

  return (
    <Card sx={{ mb: 2, border: isRead ? '1px solid #e0e0e0' : '2px solid #2196f3' }}>
      <CardContent>
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'flex-start',
            cursor: 'pointer'
          }}
          onClick={handleExpandClick}
        >
          <Box sx={{ flexGrow: 1 }}>
            <Typography variant="h5" component="div">
              {announcement.title}
              {!isRead ? (
                <FiberNewIcon color="primary" sx={{ ml: 1, verticalAlign: 'middle' }} />
              ) : (
                <CheckCircleOutlineIcon color="disabled" sx={{ ml: 1, verticalAlign: 'middle' }} />
              )}
              <IconButton size="small" sx={{ ml: 1, p: 0 }}>
                {expanded ? <ExpandLessIcon /> : <ExpandMoreIcon />}
              </IconButton>
            </Typography>
            <Typography sx={{ mb: 1.5 }} color="text.secondary">
              Posted by {announcement.authorName} on {creationDate}
            </Typography>
          </Box>
          {isLeadership && (
            <Box sx={{ flexShrink: 0, ml: 1 }}>
              <IconButton onClick={(e) => { e.stopPropagation(); onEdit(announcement); }} aria-label="edit">
                <EditIcon />
              </IconButton>
              <IconButton onClick={(e) => { e.stopPropagation(); onDelete(announcement.id); }} aria-label="delete">
                <DeleteIcon />
              </IconButton>
            </Box>
          )}
        </Box>

        <Collapse in={expanded} timeout="auto" unmountOnExit>
          <Box sx={{ mt: 2, pt: 1, borderTop: '1px solid #eee' }}>
            {/* Display rich content using dangerouslySetInnerHTML */}
            <Typography variant="body2" component="div" sx={{ whiteSpace: 'pre-wrap' }}
                        dangerouslySetInnerHTML={{ __html: announcement.content }} />

            {/* NEW: Display attachments */}
            {announcement.attachments && announcement.attachments.length > 0 && (
              <Box sx={{ mt: 2 }}>
                <Typography variant="subtitle2">Attachments:</Typography>
                <List dense>
                  {announcement.attachments.map((attachment, index) => (
                    <ListItem key={index} disablePadding>
                      <ListItemIcon sx={{ minWidth: 30 }}>
                        <AttachFileIcon fontSize="small" />
                      </ListItemIcon>
                      <ListItemText>
                        <Link href={attachment.url} target="_blank" rel="noopener noreferrer">
                          {attachment.name}
                        </Link>
                      </ListItemText>
                    </ListItem>
                  ))}
                </List>
              </Box>
            )}
          </Box>
        </Collapse>
      </CardContent>
    </Card>
  );
}

export default AnnouncementCard;